/**
 * Standard grid breakpoint configurations for product grids across the application
 */
export const STANDARD_PRODUCT_GRID_BREAKPOINTS: {
    default: number;
    [key: number]: number
} = {
    default: 5, // xxl: (1536px+): 5 columns
    1536: 5, // xxl: 5 columns
    1280: 4, // xl: 4 columns
    1024: 3, // lg: 3 columns
    768: 2, // md: 2 columns
    640: 2, // sm: 2 columns
}

/**
 * Standard spacing classes for product grid containers and items
 */
export const STANDARD_PRODUCT_GRID_SPACING = {
    /**
     * Container gap classes - responsive spacing between columns
     */
    container: "gap-2 md:gap-4 lg:gap-6 xl:gap-8",

    /**
     * Item margin classes - responsive spacing between rows
     */
    items: "mb-2 md:mb-4 lg:mb-6 xl:mb-8",
} as const